import { IShellDAO, OptionsType } from 'src/dao/IShellDAO';
import { AbstractRepository } from '../AbstractRepository';
import { ActionsMap } from './types';

export class ActionRepository extends AbstractRepository<ActionsMap> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellUserActions',
      enableSanitizer
    });
  }

  override saveAll(
    data: ActionsMap[],
    sufix?: string,
    options?: OptionsType
  ): void {
    console.log('Not supported in ActionRepository.');
    throw new Error('Method not implemented.');
  }

  override findAll(id?: string): ActionsMap[] {
    console.log('Not supported in ActionRepository.');
    throw new Error('Method not implemented.');
  }

  override delete(): boolean {
    console.log('Not supported in ActionRepository.');
    throw new Error('Method not implemented.');
  }
}
